import { 
  RegisterUserDataModel, 
} from './user-data.model';

import { 
  disableAllInputFields,
} from 'src/api/models/Form/form.utils';

import {
  BaseClass,
  dropProps,
} from 'src/api/models/Base/base.class';

import { RadioModel } from 'src/api/models/Form/RadioField/radio.model';
import { RadioClass } from 'src/api/models/Form/RadioField/radio.class';

import { InputModel } from 'src/api/models/Form/InputField/input.model';

import { InputClass } from 'src/api/models/Form/InputField/input.class';

import { SelectFieldModel } from 'src/api/models/Form/SelectField/select.model';
import { SelectFieldClass } from 'src/api/models/Form/SelectField/select.class';

import { registerUserDataForm, editUserDataForm } from './user-data.data';
import { EditUserDataModel } from './user-data.model';

export class RegisterUserData extends BaseClass<RegisterUserDataModel> implements RegisterUserDataModel {
  get gender(): RadioModel {
    return dropProps(this.props.gender, new RadioClass(this.props.gender)); 
  }
  get firstName(): InputModel {
    return dropProps(this.props.firstName, new InputClass(this.props.firstName));
  }
  get lastName(): InputModel {
    return dropProps(this.props.lastName, new InputClass(this.props.lastName));
  }
  get street(): InputModel {
    return dropProps(this.props.street, new InputClass(this.props.street));
  }
  get houseNumber(): InputModel {
    return dropProps(this.props.houseNumber, new InputClass(this.props.houseNumber));
  }
  get zip(): InputModel {
    return dropProps(this.props.zip, new InputClass(this.props.zip));
  }
  get city(): InputModel {
    return dropProps(this.props.city, new InputClass(this.props.city));
  }
  get addressAdditional(): InputModel {
    return dropProps(this.props.addressAdditional, new InputClass(this.props.addressAdditional)); 
  }
  get country(): SelectFieldModel {
    return dropProps(this.props.country, new SelectFieldClass(this.props.country)); 
  }
  get phone(): InputModel {
    return dropProps(this.props.phone, new InputClass(this.props.phone)); 
  }
  get mobile(): InputModel {
    return dropProps(this.props.mobile, new InputClass(this.props.mobile)); 
  }
  get company(): InputModel {
    return dropProps(this.props.company, new InputClass(this.props.company)); 
  }
  get branch(): RadioModel {
    return dropProps(this.props.branch, new RadioClass(this.props.branch)); 
  }
  get accountNumber(): InputModel {
    return dropProps(this.props.accountNumber, new InputClass(this.props.accountNumber)); 
  }
}

export class EditUserData extends BaseClass<EditUserDataModel> implements EditUserDataModel {
  get gender(): RadioModel {
    return dropProps(this.props.gender, new RadioClass(this.props.gender)); 
  }
  get firstName(): InputModel {
    return dropProps(this.props.firstName, new InputClass(this.props.firstName));
  }
  get lastName(): InputModel {
    return dropProps(this.props.lastName, new InputClass(this.props.lastName));
  }
  get street(): InputModel {
    return dropProps(this.props.street, new InputClass(this.props.street));
  }
  get houseNumber(): InputModel {
    return dropProps(this.props.houseNumber, new InputClass(this.props.houseNumber));
  }
  get addressAdditional(): InputModel {
    return dropProps(this.props.addressAdditional, new InputClass(this.props.addressAdditional)); 
  }
  get zip(): InputModel {
    return dropProps(this.props.zip, new InputClass(this.props.zip));
  }
  get city(): InputModel {
    return dropProps(this.props.city, new InputClass(this.props.city));
  }
  get company(): InputModel {
    return dropProps(this.props.company, new InputClass(this.props.company)); 
  }
  get country(): SelectFieldModel {
    return dropProps(this.props.country, new SelectFieldClass(this.props.country)); 
  }
  get phone(): InputModel {
    return dropProps(this.props.phone, new InputClass(this.props.phone)); 
  }
  get mobile(): InputModel {
    return dropProps(this.props.mobile, new InputClass(this.props.mobile)); 
  }
}

export const registerUserDataFormValues = () => registerUserDataForm && dropProps<RegisterUserDataModel, RegisterUserData>(
  registerUserDataForm(), 
  new RegisterUserData(registerUserDataForm())
);

export const editUserDataFormValues = () => editUserDataForm && dropProps<EditUserDataModel, EditUserData>(
  editUserDataForm(), 
  new EditUserData(editUserDataForm())
);

export const registerUserDataFormValuesDisabled = () => disableAllInputFields(registerUserDataFormValues());
